<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">任务管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>任务清单数据</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%; width: 100%">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位名称">
                <el-input
                  v-model="form.pointName"
                  clearable
                  placeholder="请输入点位名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="提交人">
                <el-input
                  v-model="form.handleUserName"
                  clearable
                  placeholder="请输入提交人"
                ></el-input>
              </el-form-item>
              <el-form-item label="所属部门">
                <el-input
                  v-model="form.handleDeptName"
                  clearable
                  placeholder="请输入所属部门"
                ></el-input>
              </el-form-item>
              <el-form-item label="事项名称">
                <el-select
                  placeholder="请选择事项名称"
                  v-model="form.eventName"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in eventList"
                    :key="item.id"
                    :label="item.sxmc"
                    :value="item.sxmc"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提交时间">
                <el-date-picker
                  v-model="form.times"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <common-table
          :select="false"
          :page="page"
          :maxHeight="500"
          :dataList="dataList"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        >
        </common-table>
      </div>
    </div>
  </div>
</template>
<script>
import { eventPage, newEventPage } from "@/api/base.js";
import commonTable from "@/components/table/index.vue";
export default {
  components: {
    commonTable,
  },
  data() {
    return {
      form: {
        pointName: "",
        handleUserName: "",
        handleDeptName: "",
        eventName: "",
        times: [],
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointName",
            label: "任务点位名称	"
          },
          {
            prop: "handleUserName",
            label: "提交人"
          },
          {
            prop: "handleDeptName",
            label: "所属部门"
          },
          {
            prop: "eventName",
            label: "事项名称	"
          },
          
          {
            prop: "handleTime",
            label: "提交时间	"
          }
        ]
      },
      eventList: []
    };
  },
  mounted() {
    this.taskPageFun();
    this.eventPageFun();
  },
  methods: {
    async eventPageFun() {
      const res = await eventPage({
        page: 1,
        size: 99999,
        ghEventTypeId: 'd10c6dde183291179f06113d400f08bb'
      });
      if (res.data.code == 200) this.eventList = res.data.data.records;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.taskPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.taskPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.taskPageFun();
    },
    onReset() {
      this.form = this.$options.data().form;
      this.page.page = 1;
      this.page.size = 10;
      this.taskPageFun();
    },
    // 分页查询
    async taskPageFun() {
      let params = {
        ...this.form,
        handleTimeStart:
          this.form.times && this.form.times.length
            ? this.form.times[0]
            : "",
        handleTimeEnd:
          this.form.times && this.form.times.length
            ? this.form.times[1]
            : "",
        page: this.page.page,
        size: this.page.size,
      };
      delete params.times;
      const res = await newEventPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.biaodan2 .biaodan-left .el-form-item {
  // width: 25%;
  // margin-right: 0 !important;
  // /deep/.el-input__inner,
  // /deep/.el-select,
  /deep/.el-date-editor {
    height: 40px;
    width: 360px !important;
  }
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  // text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskListData/index.vue